import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("hh_cookie_consent")) setShow(true);
  }, []);
  const save = (choice) => {
    localStorage.setItem("hh_cookie_consent", JSON.stringify({ choice, at: Date.now() }));
    setShow(false);
  };
  if (!show) return null;
  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 end-4 start-4 z-[60] rounded-2xl border border-emerald-900/10 bg-white p-5 shadow-2xl sm:end-auto sm:max-w-sm">
      <button onClick={() => setShow(false)} className="absolute end-3 top-3 text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>
      <p className="pe-6 text-sm leading-relaxed text-slate-600">
        We use necessary cookies to make our site work. With your consent, we may also use analytics and preference cookies. Marketing trackers are never activated without your consent.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button data-testid="cookie-accept" onClick={() => save("all")} className="rounded-full bg-emerald-900 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">Accept All</button>
        <button data-testid="cookie-reject" onClick={() => save("necessary")} className="rounded-full border border-emerald-900/20 px-4 py-2 text-sm font-semibold text-emerald-900 hover:bg-emerald-50">Reject Non-Essential</button>
      </div>
    </div>
  );
}
